module.exports = __webpack_public_path__ + "img/list1_1.dc5bb68c.png";